import { MetaData } from './metadata';
import { Supplier } from './supplier';

export class SupplierDto {
    constructor(public metadata: MetaData, public results: Supplier[]) {}
}
